export const RO = {
  "Open document": "DeschideÈi documentul",
  "Upload file": "Incarca fisier",
  "Drop file here to upload": "PlasaÈi fiÈierul aici pentru Ã®ncÄrcare",
  "Disc": "Disc",
  "URL": "URL",
  "FILE": "FIÅIER",
  "SIZE": "MÄRIMEA",
  "MB": "MB",
  "KB": "KB",
  "Bytes": "Octet",
  "Loading... Please wait.": "ÃncÄrcare va rugam asteptati.",
  "Fit Width": "LÄÈime potrivitÄ",
  "Fit Height": "ÃnÄlÈime potrivitÄ",
  "Password protected document": "Document protejat prin parolÄ",
  "Password": "Parola",
  "Open": "Deschis",
  "Password Required": "ParolÄ obligatorie",
  "Incorrect password": "Parola incorecta",
  "Error": "Eroare",
  "Something went wrong": "Ceva n-a mers bine",
  "Server is not available": "Serverul nu este disponibil",
  "of": "de",
  "Please wait...": "Va rugam asteptati..."
};
